import { render, staticRenderFns } from "./GenerateLink.vue?vue&type=template&id=1955fa6a&scoped=true"
import script from "./GenerateLink.vue?vue&type=script&lang=ts"
export * from "./GenerateLink.vue?vue&type=script&lang=ts"
import style0 from "./GenerateLink.vue?vue&type=style&index=0&id=1955fa6a&prod&lang=scss"
import style1 from "./GenerateLink.vue?vue&type=style&index=1&id=1955fa6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1955fa6a",
  null
  
)

export default component.exports